import { madlordsProducts } from './madlordsProducts.generated';

/**
 * Preferred notification channels for mocked back-in-stock alerts.
 *
 * @type {Array<{id: string, translationKey: string}>}
 */
export const notificationChannels = [
  { id: 'whatsapp', translationKey: 'PRODUCTS.CHANNELS.WHATSAPP' },
  { id: 'sms', translationKey: 'PRODUCTS.CHANNELS.SMS' },
  { id: 'email', translationKey: 'PRODUCTS.CHANNELS.EMAIL' },
];

/**
 * Mock store locations used as the seller's product workspace context.
 *
 * @type {Array<{id: string, name: string, isAll?: boolean}>}
 */
export const mockStoreLocations = [
  { id: 'all', name: 'Toutes les boutiques', isAll: true },
  { id: 'store_paris_vendome', name: 'Paris Vendôme' },
  { id: 'store_lyon_presquile', name: 'Lyon Presqu’île' },
  { id: 'store_cannes_croisette', name: 'Cannes Croisette' },
];

/**
 * Mock customer fixtures used by the product alert drawer until real contact
 * search is wired into this product workspace.
 *
 * @type {Array<Object>}
 */
export const mockCustomers = [
  {
    id: 'cust_001',
    contactId: 230,
    name: 'Marie Laurent',
    email: 'marie.laurent@example.test',
    phone: '+33611223344',
    consent: {
      whatsapp: 'subscribed',
      sms: 'unknown',
      email: 'subscribed',
    },
  },
  {
    id: 'cust_002',
    contactId: 231,
    name: 'Adam Expert',
    email: 'adam@expertify.store',
    phone: '+33761773802',
    consent: {
      whatsapp: 'unknown',
      sms: 'subscribed',
      email: 'subscribed',
    },
  },
  {
    id: 'cust_003',
    contactId: 232,
    name: 'Claire Moreau',
    email: null,
    phone: '+33699887766',
    consent: {
      whatsapp: 'not_subscribed',
      sms: 'subscribed',
      email: 'unknown',
    },
  },
];

/**
 * Static Mad Lords product catalog sample used by the mocked back-in-stock
 * workspace until Glovely has a persisted product catalog.
 *
 * @type {Array<Object>}
 */
export const mockProducts = madlordsProducts;

/**
 * Seeded product-organized waitlist rows for the mocked admin view.
 *
 * @type {Array<Object>}
 */
export const mockBackInStockAlerts = [
  {
    id: 'alert_seed_001',
    productId: 'prod_madlords_15790661173622',
    variantId: 'var_madlords_58175619793270',
    customerId: 'cust_002',
    preferredChannels: ['sms'],
    preferredChannel: 'sms',
    createdAt: '2026-07-01T09:15:00Z',
  },
  {
    id: 'alert_seed_002',
    productId: 'prod_madlords_15790661173622',
    variantId: 'var_madlords_58175619793270',
    customerId: 'cust_003',
    preferredChannels: ['email'],
    preferredChannel: 'email',
    createdAt: '2026-07-01T09:30:00Z',
  },
];
